const PropTypes = require('prop-types');
const React = require('react');
const AjaxMultiAddToCartButton = require('./ajax_multi_add_to_cart_button.jsx');

// Wrapper around AjaxMultiAddToCartButton
// * takes a single product id instead of multiple
// * instead of taking an onError callback, will render the
//   error in place.
class StandaloneAjaxAddToCartButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: null,
    };

    this.handleError = this.handleError.bind(this);
  }

  handleError(errorMessage) {
    this.setState({ errorMessage });
  }

  render() {
    if (this.state.errorMessage) {
      return <div className="alert alert-error mb-1">{this.state.errorMessage}</div>;
    }

    return (
      <AjaxMultiAddToCartButton
        productIds={[this.props.productId]}
        onError={this.handleError}
        text={this.props.text}
        className={this.props.className}
        isOwner={this.props.isOwner}
        onPreorder={this.props.onPreorder}
        aid={this.props.aid}
        source={this.props.source}
        zeroPercentAffirmFinancing={this.props.zeroPercentAffirmFinancing}
      />
    );
  }
}

StandaloneAjaxAddToCartButton.propTypes = {
  productId: PropTypes.number.isRequired,
  text: PropTypes.string,
  className: PropTypes.string,
  isOwner: PropTypes.bool,
  onPreorder: PropTypes.bool,
  aid: PropTypes.string,
  source: PropTypes.string,
  zeroPercentAffirmFinancing: PropTypes.bool,
};

module.exports = StandaloneAjaxAddToCartButton;



// WEBPACK FOOTER //
// ./javascripts/components/listings/cart/standalone_ajax_add_to_cart_button.jsx